import GModal from "components/ui/modal/Modal";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  createTransfers,
  getBranchesDropDown,
  getTransfersList,
} from "../services/transfersServices";

const CreateTransferModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, setValue } = useForm();

  const transfersData = useSelector((state) => state.inventoryTransfers);

  useEffect(() => {
    dispatch(getBranchesDropDown());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.transfers.new_transfers")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.SourceId = values.SourceId?.BranchId;
              values.DestinationId = values.DestinationId?.BranchId;
              values.UserId = localStorage.getItem("userId");
              if (
                values.SourceId === undefined ||
                values.DestinationId === undefined
              ) {
                toast2({ description: t("validation.choose_first") });
              } else {
                dispatch(createTransfers(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.transfers.created_successfuly"),
                    });
                    dispatch(getTransfersList());
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.transfers.source")}
                data={transfersData.BranchesDropDown.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("SourceId", e)}
              />

              <MultiSelect
                title={t("pages.transfers.destination")}
                data={transfersData.BranchesDropDown.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("DestinationId", e)}
              />
              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default CreateTransferModal;
